import * as types from './types';

export const setUserProfileLoading = (isLoading = false) => ({
  type: types.USER_ACCOUNT_SET_USER_PROFILE_LOADING,
  isLoading
});

export const setUserProfile = profile => ({
  type: types.USER_ACCOUNT_SET_USER_PROFILE,
  profile
});

export const resetUserProfileState = () => ({
  type: types.USER_ACCOUNT_RESET_USER_PROFILE_STATE
});

export const fetchCurrentAdministratorProfile = () => ({
  type: types.USER_ACCOUNT_FETCH_CURRENT_ADMINISTRATOR_PROFILE
});

export const fetchCurrentSchoolUserProfile = () => ({
  type: types.USER_ACCOUNT_FETCH_CURRENT_SCHOOL_USER_PROFILE
});

export const updateCurrentAdministratorProfile = (lastName, firstName, middleName) => ({
  type: types.USER_ACCOUNT_UPDATE_CURRENT_ADMINISTRATOR_PROFILE,
  lastName,
  firstName,
  middleName
});

export const setUserProfileUpdating = (isUpdating) => ({
  type: types.USER_ACCOUNT_SET_USER_PROFILE_UPDATING,
  isUpdating
});

export const setUpdatePasswordError = error => ({
  type: types.USER_ACCOUNT_SET_UPDATE_PASSWORD_ERROR,
  error
});

export const setIsUpdatingPassword = isUpdatingPassword => ({
  type: types.USER_ACCOUNT_SET_UPDATING_PASSWORD,
  isUpdatingPassword
});

export const setIsUpdatingEmail = isUpdatingEmail => ({
  type: types.USER_ACCOUNT_SET_UPDATING_EMAIL,
  isUpdatingEmail
});

export const updatePassword = (currentPassword, newPassword, onSubmitted) => ({
  type: types.USER_ACCOUNT_UPDATE_PASSWORD,
  currentPassword,
  newPassword,
  onSubmitted
});

export const updateEmail = (newEmail, onSubmitted) => ({
  type: types.USER_ACCOUNT_UPDATE_EMAIL,
  newEmail,
  onSubmitted
});

export const setSettingsUpdating = (isLoading) => ({
  type: types.USER_ACCOUNT_SET_SETTINGS_UPDATING,
  isLoading
});

export const updateAccountSettings = (accountSettings) => ({
  type: types.USER_ACCOUNT_UPDATE_SETTINGS,
  accountSettings
});

export const setUpdateEmailError = error => ({
  type: types.USER_ACCOUNT_SET_UPDATE_EMAIL_ERROR,
  error
});

export const resetUserUpdateEmailState = () => ({
  type: types.USER_ACCOUNT_RESET_USER_UPDATE_EMAIL_STATE
});


// WEBPACK FOOTER //
// ./src/actions/user-account/index.js